"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TargetDisplaySize_1 = require("./TargetDisplaySize");

var VideoPreference = /*#__PURE__*/function () {
  /** Initializes a [[VideoPreference]] with the given properties.
   *
   * @param attendeeId Attendee ID of the client
   * @param priority The relative priority of this attendee against others.
   * @param targetSize The desired maximum simulcast layers to receive.
   */
  function VideoPreference(attendeeId, priority, targetSize) {
    _classCallCheck(this, VideoPreference);

    this.attendeeId = attendeeId;
    this.priority = priority;
    this.targetSize = targetSize !== undefined ? targetSize : TargetDisplaySize_1.default.High;
  }

  _createClass(VideoPreference, [{
    key: "partialCompare",
    value: function partialCompare(other) {
      return this.priority - other.priority;
    }
  }, {
    key: "equals",
    value: function equals(other) {
      return this.attendeeId === other.attendeeId && this.targetSize === other.targetSize && this.priority === other.priority;
    }
  }, {
    key: "targetSizeToBitrateKbps",
    value: function targetSizeToBitrateKbps(targetSize) {
      switch (targetSize) {
        case TargetDisplaySize_1.default.High:
          return VideoPreference.HIGH_BITRATE_KBPS;

        case TargetDisplaySize_1.default.Medium:
          return VideoPreference.MID_BITRATE_KBPS;

        case TargetDisplaySize_1.default.Low:
          return VideoPreference.LOW_BITRATE_KBPS;
      }
    }
  }]);

  return VideoPreference;
}();

exports.default = VideoPreference;
VideoPreference.LOW_BITRATE_KBPS = 300;
VideoPreference.MID_BITRATE_KBPS = 600;
VideoPreference.HIGH_BITRATE_KBPS = 1200;